import Vue from "vue"
import { login, logout, getInfo, getMenu, resetPsw, getIsFirstLogin, getUserCollectMenu } from "@/api/user"
import { getToken, setToken, removeToken } from "@/utils/auth"
import { resetRouter } from "@/router"
import { delNullField } from "@/utils/encrypt"
import { treeToArray, translateDataToTree } from "@/utils"
import { watermark } from "@/utils"
import { apiGetNotifyType, apiGetCurrentTask } from "@/api/user"

import Cookies from "js-cookie"
import oneDimensionalArray from "@/micro/all-menu-icon-list"

const getDefaultState = () => {
  return {
    token: getToken(),
    userInfo: {},
    name: "",
    avatar: "",
    isFirstLogin: false,
    isAdmin: false,
    routes: [],
    old_routes: [],
    btnAuth: [],
    oneDimensionalMenu: [],
    unreadNotifyCount: 0, // 未读通知数量
    favoriteMenus: [], // 收藏菜单
    nowSys: "", // 当前系统前缀url
    doingTaskCount: 0 // 正在进行中的任务数量
  }
}
const getDefaultStateClear = () => {
  return {
    token: getToken(),
    userInfo: {},
    name: "",
    avatar: "",
    isFirstLogin: false,
    isAdmin: false,
    routes: [],
    old_routes: [],
    btnAuth: [],
    oneDimensionalMenu: [],
    nowSys: "", // 当前系统前缀url
    unreadNotifyCount: 0, // 未读通知数量
    doingTaskCount: 0 // 正在进行中的任务数量
  }
}

const state = getDefaultState()

const getters = {
  name: state => state.name,
  routes: state => state.routes,
  old_routes: state => state.old_routes,
  addRoutes: state => state.addRoutes,
  userInfo: state => state.userInfo,
  favoriteMenus: state => state.favoriteMenus,
  nowSys: state => state.nowSys,
  unreadNotifyCount: state => state.unreadNotifyCount,
  doingTaskCount: state => state.doingTaskCount
}

const mutations = {
  RESET_STATE: state => {
    Object.assign(state, getDefaultStateClear())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_isFirstLogin: (state, isFirstLogin) => {
    state.isFirstLogin = isFirstLogin
  },
  SET_ROUTES: (state, routes) => {
    state.routes = routes
  },
  SET_OLDROUTES: (state, routes) => {
    state.old_routes = routes
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_ISADMIN: (state, isAdmin) => {
    state.isAdmin = isAdmin
  },
  SET_BTNAUTH: (state, btnAuth) => {
    state.btnAuth = btnAuth
  },
  SET_oneDimensional_MENU: (state, menu) => {
    state.oneDimensionalMenu = menu
  },
  SET_FAVORITE: (state, favoriteMenus) => {
    state.favoriteMenus = favoriteMenus
  },
  SET_NOWSYS: (state, nowSys) => {
    state.nowSys = nowSys
  },
  SET_UNREADNOTIFYCOUNT: (state, unreadNotifyCount) => {
    state.unreadNotifyCount = unreadNotifyCount
  },
  SET_DOINGTASKCOUNT: (state, doingTaskCount) => {
    state.doingTaskCount = doingTaskCount
  }
}

const actions = {
  // 获取未读通知数量
  getUnreadNotifyCount({ commit, state }) {
    return new Promise((resolve, reject) => {
      apiGetNotifyType().then(res => {
        let unreadCount = 0
        res.data.forEach(item => {
          unreadCount = unreadCount + item.unreadCount
        })
        commit("SET_UNREADNOTIFYCOUNT", unreadCount)
      })
    })
  },

  // 获取当前用户正在进行中的任务数量
  getCurrentTask({ commit, state }) {
    return new Promise((resolve, reject) => {
      apiGetCurrentTask().then(res => {
        const count = res.data || 0
        commit("SET_DOINGTASKCOUNT", count)
      })
    })
  },

  // user login
  login({ commit }, userInfo) {
    userInfo = delNullField(userInfo)
    return new Promise((resolve, reject) => {
      login(userInfo)
        .then(({ data = {} }) => {
          // 本地开发环境 coookie 储存
          if (process.env.VUE_APP_ENV === "local") {
            if (data.ct_sso) {
              Cookies.set("ct_sso", data.ct_sso)
            } else {
              // 从本地配置文件获取 cookie
              document.cookie = process.env.VUE_APP_ENV_Cookie
            }
          }
          // const { data } = response
          commit("SET_TOKEN", data.ct_sso)
          setToken(data.ct_sso)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 获取用户信息
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then(response => {
          const { data } = response
          if (!data) {
            return reject("Verification failed, please Login again.")
          }
          const { mobile, avatar } = data
          commit("SET_NAME", mobile)
          commit("SET_AVATAR", avatar)
          commit("SET_USERINFO", data)
          // 挂载window数据，给子应用用
          window.$userInfo = data
          // 添加水印
          watermark({ watermark_txt: mobile })
          // 储存工作地
          localStorage.setItem("weChat_login_region", data.workSpace)
          // 储存登录用户
          localStorage.setItem("login_user", JSON.stringify(data))
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 判断用户是否修改原始密码
  getIsFirstLogin({ commit, state }) {
    return new Promise((resolve, reject) => {
      getIsFirstLogin()
        .then(response => {
          const { data } = response
          const { isFirstLogin, isAdmin } = data
          commit("SET_isFirstLogin", isFirstLogin)
          commit("SET_ISADMIN", isAdmin)
          // 挂载window数据，给子应用用
          window.$isFirstLogin = isFirstLogin
          window.$isAdmin = isAdmin
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 获取用户权限
  getMenu({ commit, state }) {
    return new Promise((resolve, reject) => {
      getMenu()
        .then(response => {
          const { data } = response
          commit("SET_BTNAUTH", data.authorities)
          // 挂载window数据，给子应用用
          window.$BTNAUTH = data.authorities
          if (data.menuList && data.menuList.length === 0) {
            return reject("您没有任何菜单权限，请联系管理员添加菜单")
          }
          const _menuList = data.menuList
          // 暂时去除wct手机版菜单
          for (let i = 0; i < _menuList.length; i++) {
            for (let j = 0; j < _menuList[i]["list"].length; j++) {
              if (_menuList[i]["list"][j].name === "WCT手机版") {
                _menuList[i]["list"].splice(j, 1)
                break
              }
            }
          }
          const changeKeyName = (data, sysBelong) => {
            data.forEach(item => {
              // 菜单归属
              if (item.url) {
                item.sysBelong = item.url.split("/")[1] ? "/" + item.url.split("/")[1] : item.url
              }
              item.menuId = item.id
              if (item.list) {
                item.children = item.list
                changeKeyName(item.list, sysBelong)
              }
            })
          }
          _menuList.forEach(item => {
            item.children = item.list || []
            item.menuId = item.id
            item.children.forEach(itemx => {
              itemx.sysBelong = itemx.url
              itemx.menuId = itemx.id
              if (itemx.list) {
                itemx.children = itemx.list
                changeKeyName(itemx.children, itemx.sysBelong)
              }
            })
          })
          // // 获取系统返回菜单列表，扁平化
          let menuList = treeToArray(_menuList)
          commit("SET_oneDimensional_MENU", menuList)
          // // 获取（备份全菜单）本地菜单，扁平化
          const localMenuList = oneDimensionalArray
          // 互相匹配
          menuList.forEach(item => {
            // 如果是外部url
            if (item.url.indexOf("http") > -1) {
              item.meta = { title: item.name }
            } else {
              for (let i = 0; i < localMenuList.length; i++) {
                // const title = item.meta.title || ""
                if (item.url === localMenuList[i].path) {
                  item.meta = localMenuList[i].meta
                  item.meta.title = item.name
                  item.pathName = localMenuList[i].name
                  item.hidden = localMenuList[i].hidden
                  break
                }
              }
            }
          })
          // 把扁平的数组，重新组合为路由树状图
          menuList = translateDataToTree(menuList, 0)
          console.log("处理后的菜单为Top：")
          console.log(menuList)
          commit("SET_ROUTES", menuList)
          // 挂载window数据，给子应用用
          window.$ROUTES = menuList
          resolve(menuList)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 获取用户收藏菜单
  getFavorite({ commit, state }) {
    return new Promise((resolve, reject) => {
      getUserCollectMenu()
        .then(response => {
          const { data } = response
          commit("SET_FAVORITE", data)
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 用户登出
  logout({ dispatch, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          dispatch("clearGlobal")
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 清除全局数据
  clearGlobal({ commit }) {
    removeToken() // 清除token
    resetRouter() // 重制路由
    commit("RESET_STATE")

    // 清除微信聊天相关数据
    commit("wxChat/CLEAR_ALL", null, { root: true })
    if (Vue.prototype.$nim) {
      // 断开 im 链接
      Vue.prototype.$nim.disconnect()
    }
    // 清除上一次同步数据时间戳
    localStorage.removeItem("lastSyncDataTime")
    // 清除登录用户
    localStorage.removeItem("login_user")
    /**
     * 添加beat环境判断前缀
     * 因无法布置beat服务，交由前端来进行beat环境前缀设置
     * 该方法仅在数据中心api中生效
     */
    localStorage.removeItem("env")
    // 清除水印
    const elements = document.getElementsByClassName("mask_div")
    while (elements.length > 0) {
      elements[0].parentNode.removeChild(elements[0])
    }
  },

  // 清除token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // 必须清除token
      commit("RESET_STATE")
      resolve()
    })
  },
  resetPassword({ commit }, data) {
    return resetPsw(data).then(res => {
      return res
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
